import Vue from 'vue'
import App from '../../src/App.vue'
import router from '../../src/router'
import store from '../../src/store'
import vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '../../stylesheets/global.scss'

import Vuetify from 'vuetify/lib';

Vue.config.productionTip = false

const opts = {
  theme: {
      dark: false,
      themes: {
          light: {
            primary2: '#40465B',
            primary: '#000000',
            secondary: '#FC544F',
            tertiary: '#2bcdc9',
            accent: '#5081DE',
            urgent: '#ef5350',
            substandard: '#f89c1c',
            meetsEx: '#864c9b',
            proficient: '#475f89',
            exceptional: '#68c563',
            bgGrey: '#DFE1E3',
          },
          dark: {
            primary: '#40465B',
            secondary: '#FC544F',
            tertiary: '#2bcdc9',
            accent: '#5081DE',
            urgent: '#ef5350',
            substandard: '#f89c1c',
            meetsEx: '#864c9b',
            proficient: '#475f89',
            exceptional: '#68c563',
            bgGrey: '#DFE1E3'
          }
      }
  }
}

//plugins
Vue.use(
  vuetify,
  //require('vue-moment')
  //moment,
)

new Vue({
  router,
  store,
  vuetify: new Vuetify(opts),
  render: h => h(App)
}).$mount('#app')

